import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVDropdown } from "../../shared/JVDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";

interface IProps {
    emailIDs: string[],
    open: boolean,
    toast: any,
    onHide: () => void,
}

interface IEmailForm {
    to?: string,
    subject?: string,
    req?: string | null,
    body?: string,
}

const emptyEmailBody: IEmailForm = {
    to: "",
    subject: "",
    req: null,
    body: "",
}

const schema = yup.object({
    to: yup.string().nullable(),
    subject: yup.string().required("Subject is required"),
    req: yup.string().nullable(),
    body: yup.string().nullable(),
});

export const SendEmail = (props: IProps) => {
    const [emailBody, setEmailBody] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IEmailForm>({
        resolver: yupResolver(schema),
        defaultValues: emptyEmailBody,
        shouldFocusError: false
    });

    const sendEmail = async (body: any) => {
        let checkCorrectEmail = body.to.filter((e: string) => e.includes(".") || e.includes("@"));
        if (checkCorrectEmail.length != body.to.length) {
            props.toast.current.show({ severity: 'error', detail: "Added email's are not correct", life: 3000 });
        } else {
            setLoading(true);
            const response = await Fetch("FindResume/sendEmail", "POST", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: `Email Sended Successfully`, life: 3000 });
                reset(emptyEmailBody);
                setEmailBody("");
                setLoading(false);
                props.onHide();
            } else setLoading(false);
        }
    }

    const onSubmit = (data: IEmailForm) => {
        if (emailBody.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Email Body can not be Empty.", life: 3000 });
        } else {
            let emailData: any = data;
            let arr = data?.to?.trim() !== "" ? (data?.to?.split(",").map((e: string) => e.trim()) || []) : [];
            emailData.to = arr.length > 0 ? [...props.emailIDs, ...arr] : props.emailIDs;
            emailData.subject = data.subject;
            emailData.req = data.req;
            emailData.body = emailBody;
            sendEmail(emailData);
        }
    }

    const reqs = [
        { label: "-- SELECT --", value: 0 },
    ];

    useEffect(() => {
        if (props.open) console.log(props.emailIDs);
        reset(emptyEmailBody);
        setEmailBody("");
    }, [props.open]);

    return (
        <>
            <Card>
                <p className="pl-2 text-lg">To :</p>
                <div style={{ border: "1px solid #dedede", marginTop: "-5px" }} className="pl-2 text-lg text-400 h-3rem border-round-sm flex align-items-center">{props.emailIDs.join(", ")}</div>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-5" >
                    <JVInput column={2} label="And To" control={control} name="to" />
                    <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
                    <JVInput column={2} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
                    <JVDropdown column={6} label="Req" placeholder="Select Req" control={control} name="req" options={reqs} optionValue='value' optionLabel='label' />
                    <div className="field col-12 md:col-12 mt-3" style={{ display: 'flex', gap: '10px' }}></div>
                    <div className="col-12 md:col-12">
                        <div className="flex">
                            <p className="text-base">Email Body</p><span style={{ color: 'red' }}>*</span>
                        </div>
                        <InputTextarea value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows={10} cols={30} />
                    </div>
                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6 h-2rem" loading={loading} disabled={loading} label="SEND" type="submit"></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { setEmailBody(""); reset(emptyEmailBody); }} type="button"></Button>
                    </div>
                </form>
            </Card>
        </>
    );
}